import { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { AppContext } from "../../context/AppContext";
import PropertyLabel from "../Properties/shared/PropertyLabel";
import FontAlign from "./FontAlign";
import FontFamily from "./FontFamily";
import FontItalic from "./FontItalic";
import FontLinethrough from "./FontLinethrough";
import FontSize from "./FontSize";
import FontUnderline from "./FontUnderline";
import FontWeight from "./FontWeight";
import LineHeight from "./LineHeight";
import TextMode from "./TextMode";
import { useTranslation } from "react-i18next";

function Font() {
  const { canvas, selectedObject, coreHandler } = useContext(AppContext);
  const [isFontWeightEnabled, setIsFontWeightEnabled] = useState(true);
  const [isFontItalicEnabled, setIsFontItalicEnabled] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    const fontFamily = (selectedObject as fabric.Textbox)?.get("fontFamily");
    const font = coreHandler?.fontHandler.getFontByName(fontFamily!);
    // TODO - do we need to check 1,700 ?
    setIsFontWeightEnabled(!!font?.variants?.includes("0,700"));
    setIsFontItalicEnabled(!!font?.variants?.includes("1,400"));
  }, [coreHandler?.fontHandler, selectedObject]);

  function onChange() {
    const fontFamily = (selectedObject as fabric.Textbox)?.get("fontFamily");
    const font = coreHandler?.fontHandler.getFontByName(fontFamily!);
    setIsFontWeightEnabled(!!font?.variants?.includes("0,700"));
    setIsFontItalicEnabled(!!font?.variants?.includes("1,400"));

    if (fontFamily) {
      coreHandler?.fontHandler
        .loadFont([fontFamily])
        .then(() => {
          canvas?.requestRenderAll();
        })
        .catch(() => {
          toast.error("Failed to load font, please re-select and try again");
        });
    }
  }

  return (
    <div className="space-y-4">
      <div>
        <PropertyLabel>{t("font_line_height")}</PropertyLabel>
        <LineHeight />
      </div>
      <div>
        <PropertyLabel>{t("font_family")}</PropertyLabel>
        <FontFamily onChange={onChange} />
      </div>
      <div>
        <PropertyLabel>{t("font_size")}</PropertyLabel>
        <FontSize />
      </div>
      <div>
        <PropertyLabel>{t("font_properties")}</PropertyLabel>
        <div className="flex gap-2">
          <FontWeight onChange={onChange} disabled={!isFontWeightEnabled} />
          <FontItalic onChange={onChange} disabled={!isFontItalicEnabled} />
          <FontUnderline />
          <FontLinethrough />
        </div>
      </div>
      <div>
        <PropertyLabel>{t("font_text_alignment")}</PropertyLabel>
        <FontAlign />
      </div>
      <TextMode />
    </div>
  );
}

export default Font;
